import {
  faInstagram,
  faTwitter,
  faLinkedinIn
} from '@fortawesome/free-brands-svg-icons'
import { faLink, faUser } from '@fortawesome/pro-regular-svg-icons'
import { UserQueryResult } from 'graphql/generated'
import React, { useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UserAvatar, AvatarProps } from 'components/common/Avatars'
import Link from 'next/link'
import { Typography, Button } from 'components/common'
import RoundedIconButton from 'components/common/RoundedIconButton'

interface IProps {
  user: NonNullable<UserQueryResult['user']>
  clickable?: boolean
  showSocial?: boolean
  showViewProfileButton?: boolean
  thumbnailSize?: AvatarProps['size']
}

export const ProfileBaseInfo: React.FC<IProps> = ({
  user,
  clickable = false,
  showSocial = true,
  showViewProfileButton = true
}: IProps) => {
  const actionButtons = useMemo(() => {
    return (
      <div className="flex space-y-2 sm:space-x-2 sm:space-y-0 flex-col sm:flex-row">
        {showViewProfileButton && (
          <Link href={`/profiles/${user.id}`} passHref>
            <Button
              label="View Profile"
              color="lightblue"
              size="sm"
              icon={faUser}
            />
          </Link>
        )}
      </div>
    )
  }, [showViewProfileButton, user])

  return (
    <div className="flex flex-row items-center">
      <div className="flex flex-col items-center m-4 justify-center">
        {clickable ? (
          <Link href={`/profiles/${user.id}`}>
            <UserAvatar user={user} size={'xLarge'} />
          </Link>
        ) : (
          <UserAvatar user={user} size={'xLarge'} />
        )}
      </div>

      <div className="pl-2 pr-4">
        <Typography size="heading">{user.displayName}</Typography>

        {!!user.url && (
          <Button color="link" className="px-0">
            <FontAwesomeIcon className="mr-[5px]" icon={faLink} fixedWidth />
            {user.url.replace(/https?:\/\/(www.)?/i, '')}
          </Button>
        )}

        <div className="flex pt-2 gap-4 items-center justify-between">
          {!!showSocial && !!user.instagram && (
            <RoundedIconButton
              icon={faInstagram}
              href={`https://instagram.com/${user.instagram}`}
              target="_blank"
              size="xs"
              color="lightBlue"
            />
          )}
          {!!showSocial && !!user.twitter && (
            <RoundedIconButton
              icon={faTwitter}
              href={`https://twitter.com/${user.twitter}`}
              target="_blank"
              size="xs"
              color="lightBlue"
            />
          )}
          {!!showSocial && !!user.linkedin && (
            <RoundedIconButton
              icon={faLinkedinIn}
              href={`https://twitter.com/${user.linkedin}`}
              target="_blank"
              size="xs"
              color="lightBlue"
            />
          )}

          <div className="hidden sm:flex flex-1">{actionButtons}</div>
        </div>

        <div className="sm:hidden mt-2">{actionButtons}</div>
      </div>
    </div>
  )
}
